export const THIRTY_DAYS_IN_MILLISECONDS = 2592000000;
